/* Shto sticky add to cart (phones): follows the page's buy box (the section with the given id). Shown once the visitor
   has scrolled past the buy box (it is above the screen) and at least show_after down the page; hidden while the buy box
   is in view and above it (the page's own "Claim" buttons lead to it there). The name and price are the buy box's chosen offer; the button
   presses the buy box's own add to cart button, so nothing about the cart works differently. */
(function () {
  function init(bar) {
    if (bar.shtoSticky) return;
    bar.shtoSticky = true;
    var box = document.getElementById(bar.dataset.target || 'shto-bundle-buy');
    var picker = box && box.querySelector('[data-shto-offer-picker]');
    if (!picker) return;
    var showAfter = Number(bar.dataset.showAfter || 600);
    var nameEl = bar.querySelector('[data-shto-sticky-name]');
    var priceEl = bar.querySelector('[data-shto-sticky-price]');
    var add = bar.querySelector('[data-shto-sticky-add]');
    var boxVisible = false;

    function sync() {
      var input = picker.querySelector('[data-shto-offer-input]:checked');
      var offer = input && input.closest('[data-shto-offer]');
      if (!offer) return;
      var name = offer.querySelector('.shto-offer-picker__name');
      var price = offer.querySelector('.shto-offer-picker__price');
      if (name) nameEl.textContent = name.textContent.trim();
      if (price) priceEl.textContent = price.textContent.trim();
    }
    function update() {
      var passed = box.getBoundingClientRect().bottom < 0;
      var show = window.scrollY > showAfter && passed && !boxVisible;
      bar.classList.toggle('is-shown', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      add.tabIndex = show ? 0 : -1;
    }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) { boxVisible = entries[0].isIntersecting; update(); }).observe(box);
    }
    window.addEventListener('scroll', update, { passive: true });
    picker.addEventListener('change', sync);
    add.addEventListener('click', function () {
      var real = picker.querySelector('[data-shto-offer-add]');
      if (!real || real.getAttribute('aria-busy') === 'true') return;
      add.setAttribute('aria-busy', 'true');
      real.click();
      // The buy box's own button turns busy while it adds; follow it.
      var t = setInterval(function () { if (real.getAttribute('aria-busy') !== 'true') { clearInterval(t); add.removeAttribute('aria-busy'); } }, 200);
      setTimeout(function () { clearInterval(t); add.removeAttribute('aria-busy'); }, 8000);
    });
    sync(); update();
  }
  function initAll() { document.querySelectorAll('[data-shto-sticky]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
